import React from 'react';
import { useProductMaterialInputQuery } from '../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import { IProduct } from '../../product-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function ProductMaterialInput() {
    const inputName: keyof IProduct = 'product_material_id';

    const { data } = useProductMaterialInputQuery();

    const options = data?.getProductMaterials || [];

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(FIELD_LABELS.product_material_id)}
            options={options}
        />
    );
}
